import { useDispatch, useSelector } from "react-redux";
import {BsBookmark, BsFillStarFill,BsBookmarkFill} from 'react-icons/bs';
import {MdVideoLibrary} from 'react-icons/md';
import useFetch from "../Hooks/useFetch";
import Category from "../Components/Category";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const Details = ()=>{
    const key = process.env.REACT_APP_API_KEY;
    const dispatch = useDispatch();
    const {id,isMovie} = useSelector(state=>state.DetailsReducer);
    const movies = useSelector(state=>state.WatchlistReducer);
    const [isAvailable,setAvailable] =  useState(false);
    const navigate = useNavigate();
    
    const  {results} = useFetch(`https://api.themoviedb.org/3/${(isMovie)?'tv':'movie'}/${id}?api_key=${key}&language=en-US`);

    const {results:similar} = useFetch((isMovie)?`https://api.themoviedb.org/3/tv/${id}/recommendations?api_key=${key}&language=en-US&page=1`:`https://api.themoviedb.org/3/movie/${id}/similar?api_key=${key}&language=en-US&page=1`);

    const {results:cast} = useFetch((isMovie)?`https://api.themoviedb.org/3/tv/${id}/credits?api_key=${key}&language=en-US`:`https://api.themoviedb.org/3/movie/${id}/credits?api_key=${key}&language=en-US`);

    const {results:trailer} = useFetch(`https://api.themoviedb.org/3/${(isMovie)?'tv':'movie'}/${id}/videos?api_key=${key}`)

    const handleWatchlist = ()=>{
        dispatch({type:'ADD',payload:results});
    }

    const handleTrailer = ()=>{
        dispatch({type:'TRAILER',payload:trailer});
        navigate("/Trailer")
    }

    useEffect(()=>{
        const check = movies.find(item=>item.id===results.id&&(item.name||item.title)===(results.name||results.title));
        setAvailable(check);
    },[results,movies])

    return <div className=" md:pt-16 pt-10 pb-2 dark:bg-secondary-dark min-h-screen">
        <img alt='Poster' src={`https://image.tmdb.org/t/p/original${results.backdrop_path}`} className='lg:px-8 md:px-4 px-2'/>
        <h1 className="text-headline dark:text-headline-dark font-heading lg:text-2xl md:text-xl text-lg lg:px-8 md:px-4 px-2">{results.title||results.name}</h1>
        <section className="flex flex-row items-center justify-between lg:mt-4 mt-2 lg:px-8 md:px-4 px-2 shrink">
            <span className="flex flex-row dark:text-headline-dark ">
                <h3 className="bg-gray-100 dark:bg-background-dark lg:max-w-lg md:max-w-md p-2 w-fit font-heading opacity-90">{results.release_date||results.first_air_date}</h3>
                <h3 className="flex flex-row items-center bg-gray-100 dark:bg-background-dark lg:max-w-lg md:max-w-md p-2 w-fit font-heading ml-4 opacity-90"><BsFillStarFill className="text-[orange]"/> {results.vote_average}</h3>
            </span>
            <span className="flex flex-row items-center justify-between text-headline dark:text-headline-dark font-heading lg:text-lg md:text-md text-sm">
                <button className="mr-2" onClick={handleWatchlist}>
                    {
                        (isAvailable)?
                        <BsBookmarkFill className="text-[orange]"/>
                        :
                        <BsBookmark />
                    }
                </button>
                <button className="bg-button dark:bg-button-dark shadow-lg  md:px-8 px-4 md:py-2 py-1 flex flex-row items-center" onClick={handleTrailer}><MdVideoLibrary/>Trailer</button>
            </span>
        </section>
        <div className="lg:px-8 md:px-4 px-2">
            <h2 className="text-headline dark:text-headline-dark font-heading lg:text-xl md:text-lg text-md md:mt-4 mt-2">Overview:</h2>
            <p className="text-paragraph dark:text-paragraph-dark font-body lg:text-lg md:text-md text-sm tracking-wide shadow-inner p-1 bg-gray-100 dark:bg-background-dark ">
                {results.overview}
            </p>
        </div>
        {
            (cast.cast)?
            <Category data={cast.cast} name={'Cast:'} cardType='actor'/>
            :
            null
        }
        {
            (isMovie&&results.seasons)?
            <Category data={results.seasons} name={'Seasons:'}/>
            :
            null
        }
        <Category data={similar} name={'You Might Also Like:'} cardType='movie'/>
    </div>
}

export default Details;